const API_BASE_URL = process.env.REACT_APP_API_URL;

if (!API_BASE_URL) {
  console.error('API_BASE_URL is not defined. Make sure environment variables are properly configured.');
}

export const fetchConversations = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/sms/conversations`);
    if (!response.ok) {
      throw new Error('Failed to fetch conversations');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching conversations:', error);
    throw error;
  }
};

export const fetchMessages = async (phoneNumber) => {
  try {
    console.log('Fetching messages for phone number:', phoneNumber);
    console.log('API URL:', `${API_BASE_URL}/sms/messages/${phoneNumber}`);
    const response = await fetch(`${API_BASE_URL}/sms/messages/${phoneNumber}`);
    console.log('Response status:', response.status);
    if (!response.ok) {
      throw new Error('Failed to fetch messages');
    }
    const data = await response.json();
    console.log('Fetched messages:', data);
    return data;
  } catch (error) {
    console.error('Error fetching messages:', error);
    throw error;
  }
};

export const sendMessage = async (phoneNumber, message, userName) => {
  try {
    const response = await fetch(`${API_BASE_URL}/sms/send`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        phone_number: phoneNumber,
        message: message,
        user_name: userName
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to send message');
    }

    return await response.json();
  } catch (error) {
    console.error('Error sending message:', error);
    throw error;
  }
};

export const saveContact = async (contactData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/custom_contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(contactData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to save contact');
    }

    return await response.json();
  } catch (error) {
    console.error('Error saving contact:', error);
    throw error;
  }
}; 